import { render, staticRenderFns } from "./DetailedScopeList.vue?vue&type=template&id=91e1d08e&"
import script from "./DetailedScopeList.vue?vue&type=script&lang=js&"
export * from "./DetailedScopeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports